import { useQuery } from '@tanstack/react-query';
import { User, UserRole } from '../types';

export default function useUsers(includedUserRoles: UserRole[] = [], skip: boolean = false) {
  const { data, isLoading, refetch, isError } = useQuery<User[]>({
    queryKey: ['users'],
    enabled: !skip,
  });

  // TODO: this filtering should be done on the server side
  const filteredUsers = data?.filter(user => {
    if (includedUserRoles.length === 0) return true;
    return includedUserRoles.includes(user.userRole);
  });

  return {
    users: filteredUsers || [],
    isLoading,
    refetch,
    isError,
  };
}
